import styled from 'styled-components';

export const $ErrorSpacer = styled.div`
  display: block;
  max-width: 39rem;
  width: 100%;
  margin: 1rem auto;

  & > svg {
    color: ${({ theme }) => theme?.colors?.mainTextColor ?? 'black'};
  }
`;

export const $ErrorContainer = styled.div<{ $isFull: boolean }>`
  height: ${({ $isFull }) => ($isFull ? '100vh' : null)};
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 1rem;
  background: ${({ theme }) =>
    theme?.systemColors?.defaultBackground ?? 'white'};

  align-items: center;
`;
